import { render } from "./TableCustomerData.vue?vue&type=template&id=22366828&scoped=true"
import script from "./TableCustomerData.vue?vue&type=script&lang=js"
export * from "./TableCustomerData.vue?vue&type=script&lang=js"

import "./TableCustomerData.vue?vue&type=style&index=0&id=22366828&lang=scss&scoped=true"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22366828"]])

export default __exports__